import Vue from 'vue';
import Vuex from 'vuex';
// import createPersistedState from 'vuex-persistedstate';
import user from './modules/user';
import cart from './modules/cart';
import order from './modules/order';
import layout from './modules/layout';

Vue.use(Vuex);
const context = require.context('./modules', true, /\.js$/);

export default new Vuex.Store({
  modules: {
    USER: user,
    cart,
    order,
    layout
  }
});
